import PropTypes from 'prop-types';
import React from 'react';
import { FeaturedCollection } from '~/components/modules/featuredCollection';
import { Hero } from '~/components/modules/hero';
import ImageWithText from '~/components/modules/imageWithText';
import PromoGrid from '~/components/modules/PromoGrid';
import Slideshow from '~/components/modules/slideshow';
import { LiveReplaysModule } from '~/components/modules/LiveReplaysModule';

export const Modules = ({ data, type }) => {
  switch (type) {
    case 'FeaturedCollection':
      return <FeaturedCollection data={data} />;
    case 'ImageWithText':
      return <ImageWithText data={data} />;
    case 'Slideshow':
      return <Slideshow data={data} />;
    case 'PromoGrid':
      return <PromoGrid data={data} />;
    case 'LiveReplays':
      return <LiveReplaysModule />;
    case 'HeadingBlock':
      return <Hero data={data} />;
    default:
      return <span>{type}</span>;
  }
};

Modules.propTypes = {
  data: PropTypes.object,
  type: PropTypes.string,
};
